export const updatedDatScoringReference = {
  "Biology": {
    "4": "200",
    "11": "210",
    "12": "260",
    "13": "290",
    "14": "320",
    "15": "340",
    "16": "360",
    "17": "370",
    "18": "390",
    "19": "410",
    "20": "420",
    "21": "440",
    "22": "460",
    "23": "470",
    "24": "490",
    "25": "500",
    "26": "520",
    "27": "550",
    "28": "580",
    "29": "590",
    "30": "600",
  },
  "General Chemistry": {
    "4": "200",
    "10": "210",
    "11": "240",
    "12": "280",
    "13": "310",
    "14": "330",
    "15": "350",
    "16": "360",
    "17": "380",
    "18": "400",
    "19": "410",
    "20": "430",
    "21": "440",
    "22": "460",
    "23": "470",
    "24": "490",
    "25": "510",
    "26": "530",
    "27": "550",
    "28": "570",
    "29": "580",
    "30": "600",
  },
  "Organic Chemistry": {
    "4": "200",
    "10": "210",
    "11": "260",
    "12": "300",
    "13": "320",
    "14": "330",
    "15": "350",
    "16": "370",
    "17": "380",
    "18": "400",
    "19": "410",
    "20": "430",
    "21": "450",
    "22": "470",
    "23": "480",
    "24": "490",
    "25": "510",
    "26": "530",
    "27": "550",
    "28": "560",
    "29": "570",
    "30": "600"
  },
  "Perceptual Ability": {
    "4": "200",
    "12": "210",
    "13": "250",
    "14": "280",
    "15": "310",
    "16": "340",
    "17": "360",
    "18": "390",
    "19": "410",
    "20": "430",
    "21": "450",
    "22": "470",
    "23": "500",
    "24": "520",
    "25": "550",
    "26": "580",
    "27": "580",
    "28": "590",
    "29": "600",
    "30": "600"
  },
  "Quantitative Reasoning": {
    "4": "200",
    "10": "210",
    "11": "240",
    "12": "270",
    "13": "300",
    "14": "320",
    "15": "340",
    "16": "360",
    "17": "380",
    "18": "400",
    "19": "420",
    "20": "430",
    "21": "450",
    "22": "460",
    "23": "480",
    "24": "500",
    "25": "510",
    "26": "520",
    "27": "540",
    "28": "580",
    "29": "590",
    "30": "600"
  },
  "Reading Comprehension": {
    "2": "200",
    "4": "210",
    "7": "220",
    "10": "220",
    "11": "220",
    "12": "230",
    "13": "260",
    "14": "280",
    "15": "300",
    "16": "320",
    "17": "340",
    "18": "360",
    "19": "370",
    "20": "390",
    "21": "410",
    "22": "430",
    "23": "450",
    "24": "470",
    "25": "490",
    "26": "510",
    "27": "550",
    "28": "550",
    "29": "560",
    "30": "600"
  },
  "SNS": { // not being used but leaving for reference just in case
    "2": "200",
    "4": "210",
    "6": "220",
    "8": "230",
    "10": "240",
    "11": "250",
    "12": "260",
    "13": "280",
    "14": "300",
    "15": "330",
    "16": "350",
    "17": "370",
    "18": "380",
    "19": "400",
    "20": "420",
    "21": "440",
    "22": "470",
    "23": "490",
    "24": "500",
    "25": "530",
    "26": "540",
    "27": "560",
    "28": "570",
    "29": "580",
    "30": "600"
  }
}
